import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { get, compact, isObject } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import AddUserForm from './detail/userForm';
import withLoader from '../app/withLoader';
import { withSnackbar } from 'notistack';
import { userGet, addAttributeUserValue, createUser, createAdress, createIdentity } from './_api';

const styles = (theme) => ({
  root: {
    margin: 10,
  },
  paper: {
    padding: theme.spacing.unit,
    marginBottom: 20,
  },
});

const enhance = compose(
  withSnackbar,
  withStyles(styles),
  withLoader,
  withRouter,
  connect(
    (state) => ({
      user: get(state, 'app.userData', null),
      userAttributes: get(state, 'app.userAttributes', []),
    }),
    { userGet }
  ),

  withHandlers({
    onSubmit:
      ({ toggleLoader, enqueueSnackbar, history }) =>
      async (values) => {
        toggleLoader();
        const respUser = await createUser({
          ...values.userInfo,
          username: values.userInfo.email,
        });
        const userId = get(respUser, 'data.id', false);
        const attributes = compact(get(values, 'attributes', [])).map((attr) => {
          let attribute = attr;
          if (isObject(attr)) {
            attribute = get(attr, 'value', null);
          }
          return attribute;
        });
        if (respUser && userId) {
          const respAttr = await addAttributeUserValue(userId, attributes);
          const respAddr = await createAdress(userId, {
            ...values.address,
            stateId: 1,
          });
          const respIdent = await createIdentity(userId, values.identity);
          if (
            get(respAttr, 'success', false) &&
            get(respAddr, 'success', false) &&
            get(respIdent, 'success', false)
          ) {
            enqueueSnackbar('Data o uživateli byla úspěšně uložena.', {
              variant: 'success',
            });
            history.push(`/users/${userId}`);
          } else {
            enqueueSnackbar('Data o uživateli se nepodařila uložit.', {
              variant: 'error',
            });
          }
        }
        toggleLoader(false);
      },
  })
);

export default enhance(({ classes, onSubmit }) => (
  <div className={classes.root}>
    <h2>Přidat uživatele</h2>
    <Paper className={classes.paper}>
      <AddUserForm onSubmit={onSubmit} action="add" />
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/users/add.js